import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Image1 from "./img/webp/1Protection solaire architecturale UNIK SYSTEM sur façade vitrée de bâtiment moderne.webp"
import Image15 from "./img/webp/2Technicien UNIK SYSTEM en intervention industrielle.webp"
import Image3 from "./img/webp/3Technicien UNIK SYSTEM en intervention industrielle pour l’installation et la maintenance de solutions de protection solaire.webp"
import Image4 from "./img/webp/4Protection solaire architecturale UNIK SYSTEM avec brise-soleil extérieur design moderne (5).webp"
// import Image5 from "./img/webp/5Pergola bioclimatique design UNIK SYSTEM pour terrasse professionnelle et résidentielle.webp"
import Image6 from "./img/webp/6Mur tendu imprimé floral avec miroirs lumineux LED intégrés – décoration intérieure moderne Unik System Maroc.webp"
import Image7 from "./img/webp/10Claustra décoratif architectural intérieur – séparation design et protection solaire Unik System Maroc.webp"
import Image8 from "./img/webp/11stores latéraux installée dans un jardin moderne – UNIK SYSTEM Maroc.webp"
import Image9 from "./img/webp/12Film décoratif imprimé sur vitrage pour salon de beauté, design artistique sur verre – UNIK SYSTEM Maroc.webp"
import Image10 from "./img/webp/13Stores verticaux intérieurs pour salon professionnel, gestion de la lumière et intimité – UNIK SYSTEM Maroc.webp"
import Image11 from "./img/webp/14Store banne motorisé pour terrasse de villa moderne avec protection solaire – UNIK SYSTEM Maroc.webp"
import Image12 from "./img/webp/16Façade bioclimatiquesur bâtiment professionnel avec nacelles élévatrices – UNIK SYSTEM Maroc.webp"
import Image13 from "./img/webp/18Store banne motorisé pour terrasse de villa moderne avec piscine – solution protection solaire UNIK SYSTEM.webp"
import Image14 from "./img/webp/19Stores intérieurs enrouleurs filtrants pour bureaux modernes – gestion de la lumière naturelle UNIK SYSTEM.webp"
import Image2 from "./img/webp/20Intervention technique en hauteur pour installation de façade vitrée et brise-soleil – équipe UNIK SYSTEM.webp"
import Image16 from "./img/webp/21Schéma technique de brise-soleil architectural réduisant l’impact solaire et améliorant le confort thermique.webp"
import Image17 from "./img/webp/22Salle de conférence équipée de stores intérieurs occultants pour protection solaire et confort visuel_imgupscaler.ai_B.webp"
import Image18 from "./img/webp/23Store screen extérieur vertical pour terrasse, protection solaire et intimité.webp"
import Image19 from "./img/webp/25Stores intérieurs enrouleurs installés dans un espace commercial moderne.webp"
import Image20 from "./img/webp/26Stores screen zip extérieurs sur façade vitrée moderne, réduction de chaleur et éblouissement.webp"
import Image21 from "./img/webp/27Installation de films ou stores solaires dans bureaux professionnels avec vue panoramique.webp"
import Image22 from "./img/webp/28Bureau open space moderne avec stores solaires intérieurs pour contrôle de la lumière naturelle et confort thermique.webp"
import Image23 from "./img/webp/29Store enrouleur intérieur avec mécanisme à chaînette, solution de protection solaire élégante pour fenêtres.webp"
import Image24 from "./img/webp/30Cloisons vitrées de bureau avec films décoratifs et bandes dépolies pour intimité et design professionnel UNIK SYSTEM.webp"
import Image25 from "./img/webp/31Bureaux professionnels équipés de stores solaires intérieurs pour réduction de l’éblouissement et confort visuel.webp"
import Image26 from "./img/webp/32Façade architecturale équipée d’écrans solaires textiles pour protection thermique et design contemporain_imgupscaler..webp"
import Image27 from "./img/webp/33Installation de film solaire sur vitres de transport pour réduction de chaleur et protection UV.webp"
import Image28 from "./img/webp/34Bureau moderne avec films solaires sur vitrages pour confort thermique et confidentialité.webp"
import Image29 from "./img/webp/35Cloisons vitrées de bureau avec films décoratifs et bandes dépolies pour intimité et design professionnel UNIK SYSTEM.webp"
import Image30 from "./img/webp/36Grand espace professionnel avec vitrages équipés de solutions de protection solaire et éclairage naturel maîtrisé.webp"






const images = [
  { id: 1, src: Image1,title: "Installation de films solaires architecturaux" },
  { id: 2, src: Image2, title: "Pose de film solaire sur façade vitrée" },
  { id: 3, src: Image3, title:"Pose de film solaire sur le Tramway Casa"},
  { id: 4, src: Image4, title:"Pose de film solaire sur façade vitrée" },
  // { id: 5, src: Image5, title:"Pergola moderne pour terrasse de restaurant" },
  { id: 6, src: Image6, title:"Film décoratif design pour intérieur moderne"},
  { id: 7, src: Image7, title:"Film décoratif opacifiant pour vitrage"},
  { id: 8, src: Image8, title:"Pergola bioclimatique avec stores latéraux"},
  { id: 9, src: Image9, title:"Film décoratif artistique pour vitrine"},
  { id: 10, src: Image10, title:"Solutions de Stores Verticaux Modernes" },
  { id: 11, src: Image11, title:"Rideaux et Stores Intérieurs – Élégance et Confort"},
  { id: 12, src: Image12, title:"Installation de Toile Bioclimatique en Façade"},
  { id: 13, src: Image13, title:"Store Banne Extérieur pour Terrasse et Piscine"},
  { id: 14, src: Image14, title:"Store Enrouleur Intérieur – Lumière Naturelle"},
  { id: 15, src: Image15, title:"Tour Mohammed VI – Solutions avancées pour façades vitrées et protection solaire"},
  { id: 16, src: Image16, title:"Façade textile dynamique pour la protection solaire et le confort thermique" },
  { id: 17, src: Image17, title:"Stores intérieurs motorisés pour un contrôle optimal de la lumière et du confort visuel"},
  { id: 18, src: Image18, title:"Store vertical extérieur zip pour une protection solaire et climatique optimale"},
  { id: 19, src: Image19, title:"Store vertical extérieur ZIP : protection solaire moderne et élégante pour façades vitrées"},
  { id: 20, src: Image20, title:"Stores enrouleurs intérieurs"},
  { id: 21, src: Image21, title: "Installation de film solaire pour bureaux"},
  { id: 22, src: Image22, title:"Installation de stores intérieurs" },
  { id: 23, src: Image23, title:"Stores enrouleurs intérieurs"},
  { id: 24, src: Image24, title:"Film décoratif sablé pour cloisons vitrées de bureaux"},
  { id: 25, src: Image25, title:"Stores enrouleurs techniques"},
  { id: 26, src: Image26, title:"Façade textile bioclimatique – protection solaire et performance architecturale"},
  { id: 27, src: Image27, title:"Installation de film solaire à bord du tramway de Casablanca"},
  { id: 28, src: Image28, title:"Film décoratif dépoli pour cloisons vitrées de bureaux" },
  { id: 29, src: Image29, title:"Film décoratif sablé pour cloisons vitrées de bureaux"},
  { id: 30, src: Image30, title:"Habillage de façade architecturale en toile technique"},
];
const Gallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  

  return (
    <>
      {/* ===== Title ===== */}
      <div className="container titre-gallry projects-header" id="titre-gallry">
        <h2 data-aos="fade-up" className="section-titles">
          Nos Réalisations – Projets & Installations Professionnelles
        </h2>
        <p data-aos="fade-up">
          Découvrez nos projets réalisés avec expertise et précision.
        </p>
      </div>

      {/* ===== Gallery ===== */}
      <div className="simple-gallery">
        {images.map((img) => (
          <div data-aos="zoom-in" key={img.id} className="gallery-item">
            <img src={img.src} alt={img.title} />

            {/* ✅ Zoom button */}
            <button
              className="zoom-icon"
              onClick={() => setActiveItem(img)}
              aria-label="Zoom image"
              loading="lazy"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* ===== Lightbox ===== */}
      {activeItem && (
        <div className="lightbox" onClick={() => setActiveItem(null)}>
          <div className="content" onClick={(e) => e.stopPropagation()}>
            <img src={activeItem.src} alt={activeItem.title} loading="lazy"/>
            
            {/* ✅ TITLE */}
            <div className="image-title">
              {activeItem.title}
            </div>

            <button
              className="close"
              onClick={() => setActiveItem(null)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
